module.exports = __webpack_public_path__ + "static/media/goodday_data.8296b907.png";